import { useMemo } from 'react'
import { findKey } from 'lodash-es'
import { useTbViewStore, useProjectStore, useAppEx } from '@vt/hooks'
import { Tab } from '@ow/comps'

const tabConfig = {
  attribute: {
    name: (title) => `${title}属性`,
    properties: [
      {
        is: ['clickedId'],
      },
    ],
  },
  list: {
    name: (title) => `${title}列表`,
    properties: [
      {
        not: ['clickedId'],
      },
      {
        not: ['isLastLevel'],
      },
    ],
  },
  user: {
    name: '绑定用户',
    properties: [
      {
        is: ['areaBindUserTbId'],
        // not: ['clickedId'],
      },
    ],
    project: {
      not: ['yyzcjc'],
    },
  },
  standard: {
    name: '绑定指标',
    project: {
      not: ['ddqljfl', 'hdhjjs'],
    },
  },
  logicSpec: {
    name: '逻辑设置',
    project: {
      is: ['yyzcjc'],
    },
  },
  geo: {
    name: '点位地图',
    project: {
      is: [],
    },
  },
  massif: {
    name: '地图模式',
    project: {
      is: ['qjzhyl', 'hdhjjs'],
    },
  },
  ref: {
    name: '绑定',
    properties: [
      {
        is: ['isLastLevel', 'clickedId'],
      },
      {
        is: ['multiSelect'],
      },
    ],
    project: {
      not: ['ddqljfl', 'syhjws'],
    },
  },
  cal: {
    name: '指标统计',
    properties: [
      {
        is: ['isLastLevel', 'clickedId'],
      },
      {
        is: ['multiSelect'],
      },
    ],
    project: {
      is: ['ljfl-xq'],
    },
  },
  createRepeatlyCheck: {
    project: {
      is: ['yyzcjc'],
    },
  },
}

// 状态判断
const getPropertiesValidator = (props) => (key) => {
  const cfg = tabConfig[key].properties

  if (!cfg) return true

  return cfg.some((c) => {
    if (c.is && c.is.some((i) => !props[i])) return false

    if (c.not && c.not.some((i) => props[i])) return false

    return true
  })
}

// 项目判断
const getProjectValidator = (cusKey) => (key) => {
  const cfg = tabConfig[key].project

  if (!cfg) return true

  if (cfg.is) {
    return cfg.is.includes(cusKey)
  }

  if (cfg.not) {
    return !cfg.not.includes(cusKey)
  }

  return true
}

export const useTabVisible = (title) => {
  const cusKey = useProjectStore((state) => state.cusKey)
  const projectValidator = getProjectValidator(cusKey)

  const {
    clickedId = null,
    isLastLevel = false,
    multiSelect = false,
  } = useTbViewStore((state) => state.clickedInfo)

  const tbs = useAppEx((state) => state.tbs)

  const areaBindUserTbId = useMemo(
    () =>
      findKey(tbs, (tb) => {
        return tb.extend.areaBindUser
      }),
    [tbs]
  )

  const propertiesValidator = getPropertiesValidator({
    isLastLevel,
    clickedId,
    multiSelect,
    areaBindUserTbId,
  })

  const getTabName = (key) =>
    typeof tabConfig[key].name === 'function'
      ? tabConfig[key].name(title)
      : tabConfig[key].name

  const tabRender = (key, children) =>
    projectValidator(key) && propertiesValidator(key) ? (
      <Tab.TabPane key={key} tab={getTabName(key)}>
        {children}
      </Tab.TabPane>
    ) : null

  return {
    tabRender,
    clickedId,
    areaBindUserTbId,
  }
}

export const useProjectValidator = () => {
  const cusKey = useProjectStore((state) => state.cusKey)
  return getProjectValidator(cusKey)
}
